/**
 * GeChiUI dependencies
 */
import { createContext, useContext } from '@gechiui/element';

export const NavigationGroupContext = createContext( { group: undefined } );

export const useNavigationGroupContext = () =>
	useContext( NavigationGroupContext );
